class PremiumSocialProofCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-social-track]');
    this.prevBtn = this.querySelector('[data-social-prev]');
    this.nextBtn = this.querySelector('[data-social-next]');
    if (!this.track) return;

    this.prevBtn?.addEventListener('click', () => this.scroll(-1));
    this.nextBtn?.addEventListener('click', () => this.scroll(1));
    this.track.addEventListener('scroll', () => this.sync(), { passive: true });
    this.sync();
  }

  scroll(direction) {
    const card = this.track.querySelector('.premium-social-proof__story');
    const gap = parseFloat(getComputedStyle(this.track).gap) || 16;
    const amount = card ? card.offsetWidth + gap : this.track.clientWidth * 0.9;
    this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  sync() {
    if (!this.prevBtn || !this.nextBtn) return;
    const max = this.track.scrollWidth - this.track.clientWidth - 2;
    this.prevBtn.disabled = this.track.scrollLeft <= 2;
    this.nextBtn.disabled = this.track.scrollLeft >= max;
  }
}

customElements.define('premium-social-proof-carousel', PremiumSocialProofCarousel);
